
import { FormState, LOCAL_STORAGE_KEY } from './types';
import { initialState } from './formReducer';

// Try to load initial state from localStorage
export const loadInitialState = (): FormState => {
  if (typeof window === 'undefined') return initialState;
  
  try {
    const savedData = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      return {
        ...initialState,
        currentPage: parsedData.currentPage || 1,
        formData: parsedData.formData || {},
      };
    }
  } catch (error) {
    console.error('Error loading form data from localStorage:', error);
  }
  
  return initialState;
};

// Save form data to localStorage
export const saveToLocalStorage = (currentPage: number, formData: FormState['formData']) => {
  try {
    const dataToSave = {
      currentPage,
      formData,
    };
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(dataToSave));
  } catch (error) {
    console.error('Error saving form data to localStorage:', error);
  }
};

// Clear localStorage data
export const clearLocalStorage = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing form data from localStorage:', error);
  }
};
